import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getResourceSamples } from 'services/resources';

export default function useResourcesSamples(
  uuids: string[],
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    [`resources-samples`, uuids],
    () => {
      return getResourceSamples(uuids).then((response) => {
        if (!response.ok) {
          throw new Error(response?.originalError?.message || '');
        }
        return response.data;
      });
    },
    {
      ...options,
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: true,
    }
  );
}
